import React from 'react';
import { IconButton, IconButtonProps, styled } from '@mui/material';


interface ActiveMoreProps extends IconButtonProps {
    active: boolean;
    degrees: number;
}

export const ActiveMore = styled((props: ActiveMoreProps) => {
    const { active, ...other } = props;
    return (
        <>
            <IconButton {...other} />
        </>
    );
})(({ theme, active, degrees}) => ({
    transform: !active ? 'rotate(0deg)' : `rotate(${degrees}deg)`,
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));